<template>
  <div class="renwu">
    <!-- 任务管理 -->
    <div class="top">
      <Select v-model="model1" class="select" @on-change="getSelect">
        <Option v-for="(item, index) in typeList" :value="item.name" :key="index">{{ item.name }}</Option>
      </Select>
      <Input v-model="searchValue" @on-clear="searchReservationTaskList(1)" @on-enter="searchReservationTaskList(1)" v-if="this.selectName == '团体名称'" placeholder="请输入团体名称进行搜索" clearable class="journal-input">
      <Icon type="ios-search" slot="prefix" />
      </Input>
      <!-- <Date-picker @on-change="changeDate" type="daterange" :options="options2" ></Date-picker> -->
      <Date-picker @on-change="changeDate" v-if="this.selectName == '任务开始时间'" class="data" v-model="datemodel" :options="options" type="daterange" placeholder="选择日期"></Date-picker>
      <Select v-if="this.selectName == '上传状态'" v-model="model2" class="select" @on-change="getSelect2">
        <Option v-for="(item, index) in postList" :value="item.name" :key="index">{{ item.name }}</Option>
      </Select>
      <Button class="title-btn2" type="success" ghost @click="setSpecialTask">设置特殊任务</Button>
    </div>
    <div class="table-cont">
      <Table @on-sort-change="changesort" @on-selection-change="selectChange" stripe :columns="columns" :data="data"></Table>
    </div>
    <div class="page-div">
      <div class="page-div-left">
        已选 <span>{{ selectNum }}</span> 条
      </div>
      <Page :total="obj.total" @on-page-size-change="changepeoplepage" @on-change="changePeoplecurrent" show-elevator show-total :current="current" :page-size="pageSize" show-sizer class="page-div-page" />
    </div>
    <!--   <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success">操作成功</Alert> -->
    <Alert class="alertTitle" v-show="alertTitleIshow2" type="error" show-icon>{{ alertTitle }}</Alert>

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
    <!-- 弹框 -->
    <Modal class="ivumodal" footer-hide width="850" v-model="numShow" title="失败清单">
      <div class="title">
        请返回体检软件修改个人基本信息，系统每整点时自动上传失败数据
      </div>
      <Failnum ref="Failnum" :idOrgReservation="id"></Failnum>
    </Modal>

    <Modal class="ivumodal" footer-hide width="850" v-model="numShows" title="成功清单">
      <div class="title">
        修改状态中的不可重传原因：1、体检者已预约。 2、体检者已登记。
      </div>
      <Sucesse ref="Sucesse" :idOrgReservation="id"></Sucesse>
    </Modal>

    <Modal footer-hide class="ivumodal" width="500" v-model="specialVerify" title="设置特殊任务确认">
      <div class="ivumodal-cont" style="line-height:40px;font-size:16px;">
        是否要将这{{selectNum}}个任务设置为特殊任务
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="specialVerify = false">取消</Button>
        <Button class="btn sure" type="success" ghost @click="setSuccess">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  searchReservationTaskList,
  uploadReservationTask,
  updateReservationByUnbespoken,
  saveTaskIsSpecialTask,
} from "../servers/api";

import Failnum from "../tan/failnum";
import Sucesse from "../tan/sucusse";
import { stringify } from "querystring";
export default {
  name: "renwu",
  data() {
    return {
      isiconfontshow: false,
      /*  alertTitleIshow: false, */
      alertTitleIshow2: false,
      alertTitle: "",
      searchValue: "",
      options: {
        shortcuts: [
          {
            text: "最近一周",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: "最近一个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: "最近三个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
      numShows: false,
      typeList: [
        {
          name: "任务开始时间",
        },
        {
          name: "团体名称",
        },
        {
          name: "上传状态",
        },
      ], //select选择筛选
      postList: [
        {
          name: "已上传",
        },
        {
          name: "未上传",
        },
        /* {
          name: "可预约",
        }, */
      ],
      selectName: "团体名称", //select选项展示
      model1: "团体名称",
      model2: "已上传",
      data: [],
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
          // "fixed": "left",
        },
        {
          title: "团体名称",
          // width: 200,
          align: "center",
          key: "orgName",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "任务ID",
          // width: 200,
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "reservationName",
        },
        {
          title: "任务开始日期",
          // width: 200,
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "dateContinue",
        },
        {
          title: "任务结束日期",
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "dateReservation",
          render: (h, params) => {
            let num = "";
            if (params.row.dateReservation) {
              num = params.row.dateReservation.slice(0, 10);
            }
            return h(
              "div",
              {
                style: {
                  height: "30px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "12px",
                  color: "#7F7F7F",
                  "font-family": "SimHei",
                },
              },
              num
            );
          },
        },
        {
          title: "任务人数",
          align: "center",
          ellipsis: true,
          width: 120,
          sortable: true,
          key: "peCount",
        },
        {
          title: "上传成功人数",
          align: "center",
          ellipsis: true,
          width: 140,
          sortable: true,
          key: "faCount",
          render: (h, params) => {
            let num = params.row.suCount;
            let color = "";
            if (num > 0) {
              color = "#53CAC3";
            } else {
              color = "#7F7F7F";
            }
            return h(
              "div",
              {
                style: {
                  height: "30px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "13px",
                  color: color,
                  cursor: "pointer",
                  "font-weight": "700",
                },
                on: {
                  click: () => {
                    if (params.row.suCount > 0) {
                      this.succesLoad(params.row);
                    }
                  },
                },
              },
              num
            );
          },
        },
        {
          title: "上传失败人数",
          align: "center",
          ellipsis: true,
          width: 140,
          sortable: true,
          key: "faCount",
          render: (h, params) => {
            let num = params.row.faCount;
            let color = "";
            if (num > 0) {
              color = "#53CAC3";
            } else {
              color = "#7F7F7F";
            }
            return h(
              "div",
              {
                style: {
                  height: "30px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "13px",
                  color: color,
                  cursor: "pointer",
                  "font-weight": "700",
                },
                on: {
                  click: () => {
                    if (params.row.faCount > 0) {
                      this.uploadFail(params.row);
                    }
                  },
                },
              },
              num
            );
          },
        },
        {
          title: "操作",
          key: "awssd",
          align: "center",
          width: 170,
          // "fixed": "right",
          render: (h, params) => {
            let back = "#fff";
            var name = "";
            let color = "#7F7F7F";
            name = "立即上传";
            back = "#53CAC3";
            color = "#fff";
            /* if (params.row.rstateCode == 2) {
              name = "已允许";
              back = "#fff";
              color = "#7F7F7F";
            } else if (params.row.rstateCode == 1) {
              name = "允许预约";
              back = "#53CAC3";
              color = "#fff";
            } */
            return h("span", [
              h("i-switch", {
                //数据库1是已处理，0是未处理
                props: {
                  type: "primary",
                  trueColor: "#53cac3",
                  value: params.row.rstateCode === "1", //控制开关的打开或关闭状态，官网文档属性是value
                },
                style: {
                  marginRight: "7px",
                  marginBottom: "5px",
                },
                on: {
                  "on-change": (value) => {
                    //触发事件是on-change,用双引号括起来，
                    //参数value是回调值，并没有使用到
                    this.switchChange(params.row, value); //params.index是拿到table的行序列，可以取到对应的表格值
                  },
                },
              }),
              h(
                "div",
                {
                  style: {
                    // width:'50px',
                    height: "28px",
                    "line-height": "28px",
                    "text-align": "center",
                    "font-size": "13px",
                    background: back,
                    border: "1px solid #53CAC3",
                    "border-radius": "5px",
                    width: "65px",
                    "margin-left": "12px",
                    cursor: "pointer",
                    display: "inline-block",
                    color: color,
                  },
                  on: {
                    click: () => {
                      this.allow(params.row);
                    },
                  },
                },
                name
              ),
            ]);
          },
        },
      ],
      current: 1,
      selectNum: 0, //已选数量
      selectList: [],
      pageSize: 20,
      numShow: false,
      datemodel: [],
      rStateCode: "",
      orderField: "", //排序字段
      isAsc: "",
      obj: {},
      id: "",
      specialVerify: false,
    };
  },
  created() {
    this.searchReservationTaskList();
  },
  methods: {
    switchChange(e, value) {
      if (value) {
        let params = {
          fpms: 1,
          idOrgReservation: e.idOrgReservation,
        };
        updateReservationByUnbespoken(params).then((res) => {
          this.allow(e);
        });
      } else {
        let params = {
          fpms: 0,
          idOrgReservation: e.idOrgReservation,
        };
        updateReservationByUnbespoken(params).then((res) => {});
      }
      /* console.log(e.organizationId, e.planDate, value);
      let disable = value ? 0 : 1;
      updateBookingTimePlanOrgByFdisable({
        organizationId: e.organizationId,
        planDate: e.planDate,
        disable: disable,
      }).then((res) => {
        if (res.data.code === 1) {
          if (value) {
            this.$Message.success("已打开预约");
          } else {
            this.$Message.success("已禁用预约");
          }
        }
      }); */
    },
    succesLoad(item) {
      //点击上传成功人数
      this.id = item.idOrgReservation.toString();
      this.$refs.Sucesse.pagenum(1);
      this.$refs.Sucesse.selectUploadFailPatientList(item.idOrgReservation);
      this.numShows = true;
    },
    allow(item) {
      /* //允许预约 */
      // 立即上传
      console.log("22");

      this.isiconfontshow = true;
      let params = {
        idOrgReservation: item.idOrgReservation,
      };
      uploadReservationTask(params).then((res) => {
        console.log(res, "111");
        if (res.data.code == 1) {
          /*  this.isiconfontshow = false; */
          /*  this.alertTitleIshow = true; */
          /* setTimeout(() => {
            this.alertTitleIshow = false;
          }, 2000); */
          this.$Message.success("操作成功");
          this.searchReservationTaskList();
        }
      });
    },
    changeDate(data) {
      //日期
      this.datemodel = data;
      this.searchReservationTaskList();
    },
    uploadFail(item) {
      //点击表格里的上传失败人数
      this.id = item.idOrgReservation.toString();
      this.$refs.Failnum.pagenum(1);
      this.$refs.Failnum.selectUploadFailPatientList(item.idOrgReservation);
      this.numShow = true;
    },
    changePeoplecurrent(num) {
      //换页
      this.current = num;
      this.searchReservationTaskList();
    },
    changepeoplepage(num) {
      //换每页请求多少条
      this.pageSize = num;
      this.current = 1;
      this.searchReservationTaskList();
    },
    getSelect2(name) {
      //上传状态
      /*  if (name == "部分上传失败") {
        this.rStateCode = "1";
      } else if (name == "已完整上传") {
        this.rStateCode = "1";
      } else {
        this.rStateCode = "0";
      } */
      if (name == "已上传") {
        this.rStateCode = "1";
      } else if (name == "未上传") {
        this.rStateCode = "0";
      }
      this.searchReservationTaskList();
    },
    getSelect(name) {
      //任务创建时间select
      this.selectName = name;
      this.datemodel = [];
      this.searchValue = "";
      this.rStateCode = "";
      if (this.selectName == "上传状态") {
        this.rStateCode = "1";
      }
      this.current = 1;
      this.searchReservationTaskList();
    },
    changesort(item) {
      //排序
      this.orderField = item.key;
      this.isAsc = item.order;
      this.current = 1;
      if (item.order == "normal") {
        this.isAsc = "";
        this.orderField = "";
      }
      this.searchReservationTaskList();
    },
    selectChange(item) {
      //多选选择table'
      this.selectList = item;
      this.selectNum = this.selectList.length;
    },
    searchReservationTaskList(index) {
      this.isiconfontshow = true;
      if (index) {
        this.current = 1;
      }
      if (typeof this.datemodel[0] == "object") {
        var d = new Date(this.datemodel[0]);
        this.datemodel[0] =
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
      }
      if (typeof this.datemodel[1] == "object") {
        var d = new Date(this.datemodel[1]);
        this.datemodel[1] =
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
      }
      let params = {
        pageNum: this.current,
        pageSize: this.pageSize,
        startDate: this.datemodel[0],
        endDate: this.datemodel[1],
        orgName: this.searchValue,
        rStateCode: this.rStateCode,
        orderField: this.orderField,
        isAsc: this.isAsc,
      };
      searchReservationTaskList(params).then((res) => {
        if (res.data.code == 1) {
          this.selectChange([]);
          this.isiconfontshow = false;
          this.obj = res.data.data;
          this.data = res.data.data.list;
        }
      });
    },
    setSpecialTask() {
      this.specialVerify = true;
    },
    setSuccess() {
      let idArr = [];
      this.selectList.forEach((element) => {
        idArr.push(element.idOrgReservation);
      });
      saveTaskIsSpecialTask({
        ids: idArr.toString(),
      }).then((res) => {
        if (res.data.code === 1) {
          this.specialVerify = false;
          this.$Message.success("设置成功");
          this.searchReservationTaskList();
        }
      });
    },
  },
  components: {
    Failnum,
    Sucesse,
  },
};
</script>
<style lang="scss" scoped="" type="text/css">
@import "../font/iconfont.css";
@import "../css/conmmon.scss";
.ivumodal /deep/ {
  font-family: SimHei;
  color: #7f7f7f;
  .title {
    color: #f59a23;
    width: 100%;
    text-align: center;
    position: absolute;
    top: 15px;
  }
}

.renwu {
  font-family: SimHei;
  font-size: 13px;
  padding: 15px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  overflow-y: visible;
  .top {
    width: calc(100% - 250px);
    height: 60px;
    line-height: 35px;
    position: fixed;
    top: 111px;
    z-index: 99;
    background: #fff;
    padding-top: 17px;
    left: 220px;
    padding-left: 15px;
    padding-bottom: 15px;
    .title-btn2 {
      width: 110px;
      float: right;
      margin-left: 10px;
      line-height: 18px;
    }
  }
  .select {
    width: 130px;
    margin-right: 10px;
  }
  .journal-input {
    width: 250px;
    vertical-align: top;
  }
  .data {
    width: 250px;
    vertical-align: top;
  }
  .table-cont {
    padding-top: 15px;
    margin-top: 35px;
    margin-bottom: 60px;
  }
  .page-div {
    width: 100%;
    margin-top: 15px;
    position: fixed;
    background: #fff;
    width: calc(100% - 270px);
    height: 60px;
    z-index: 99;
    bottom: 0;
    padding-top: 15px;
    .page-div-left {
      float: left;
    }
    .page-div-page {
      float: right;
      margin-right: 15px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/yuyue/renwu.vue